import { NumericFormat } from 'react-number-format';
import React, { useState, useEffect } from 'react';
import { getTranslations } from '../../../../../../services/languageUtils';

function TransferOrderResume({
  currentPayment,
  currentBalance,
  updateValueTransfer,
  getMaskPass,
  writePassword,
  sendPayment,
  loadingTranfer,
  back,
  updateDescription,
  resSearchExternalKey
}){
  const [translations, setTranslations] = useState({});

  useEffect(() => {
    const loadTranslations = async () => {
      const trans = await getTranslations((localStorage.getItem('language') || 'pt'));
      setTranslations(trans);
    };
    loadTranslations();
  }, []);

  return (
    <div>
      <div className="mainContent">
        <p className="pTitle">
          {translations.transfer_order_resume}
        </p>
        <p className="pLabel">{currentPayment.creditParty.name}</p>

        <div className="contentSpaceBetween">
          <p className="labelGray">
            {translations.pix_key}
          </p>
          <b>{currentPayment.creditParty.key}</b>
        </div>
        <div className="contentSpaceBetween">
          <p className="labelGray">
            {translations.branch}
          </p>
          <b>{resSearchExternalKey.account.branch}</b>
        </div>
        <div className="contentSpaceBetween">
          <p className="labelGray">
            {translations.account}
          </p>
          <b>{resSearchExternalKey.account.account}</b>
        </div>
        <div className="contentSpaceBetween">
          <p className="labelGray">
            {translations.doc}
          </p>
          <b>{resSearchExternalKey.owner.documentNumber}</b>
        </div>
        <div className="contentSpaceBetween">
          <p className="labelGray">
            {translations.description}
          </p>
          <textarea
            id="pixDescription"
            name="pixDescription"
            placeholder={translations.description_placeholder}
            rows="4"
            cols="30"
            onChange={(e) => {updateDescription(e.target.value)}}
          ></textarea>
        </div><br /><br />
        <div onClick={() => back(0)} className="backButton">
          <b>{translations.back_to_contacts_info}</b>
        </div>
      </div>

      <div className="mainContent" style={{ borderRadius: "0px 8px 8px 0px" }}>
        <p className="pTitle spaceBetween">
          <span>{translations.amount}</span>
          <span style={{ fontWeight: "700" }}>
            {translations.currency_prefix} {currentBalance.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
          </span>
        </p>
        <div style={{display: "flex", marginTop: "10px"}}>
          <div>
            <span className="labelGray">{translations.how_much_transfer}</span>
            <NumericFormat
                className="input"
                value={currentPayment.amount}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale
                prefix={translations.currency_prefix}
                onValueChange={(values) => {
                  const { value } = values;
                  updateValueTransfer(value);
                }}
              />
            </div>
          </div><br/>
        
        <div>
          <p className="pTitle">
            {translations.authentication}
          </p>
          <div style={{display: "flex", paddingTop: "15px"}}>
            <div style={{width: "240px"}}>
              <p style={{fontSize: "14px"}}>
                {translations.enter_password}
              </p><br/>
              <div className="simulateInput">
                {getMaskPass()}
              </div>
            </div>

            <div style={{textAlign: "right"}}>
              <div className="inputPassword" onClick={()=>{writePassword("0")}}>
                0
              </div>
              <div className="inputPassword" onClick={()=>{writePassword("1")}}>
                1
              </div>
              <div className="inputPassword" onClick={()=>{writePassword("2")}}>
                2
              </div>
              <div className="inputPassword" onClick={()=>{writePassword("3")}}>
                3
              </div>
              <div className="inputPassword" onClick={()=>{writePassword("4")}}>
                4
              </div><br/>
              <div className="inputPassword" onClick={()=>{writePassword("5")}}>
                5
              </div>
              <div className="inputPassword" onClick={()=>{writePassword("6")}}>
                6
              </div>
              <div className="inputPassword" onClick={()=>{writePassword("7")}}>
                7
              </div>
              <div className="inputPassword" onClick={()=>{writePassword("8")}}>
                8
              </div>
              <div className="inputPassword" onClick={()=>{writePassword("9")}}>
                9
              </div><br/>
              <div className="inputPassword" onClick={()=>{writePassword("del")}} style={{width: "83px"}}>
                {translations.delete}
              </div>
            </div>
          </div>
        </div>

        <div 
          className={`buttonSend ${loadingTranfer ? 'disabled' : ''}`} 
          onClick={!loadingTranfer ? () => {sendPayment(2)} : null}
        >
          {loadingTranfer ? <div className="loader"></div> : translations.complete_transfer}
        </div>
      </div>
    </div>
  );
}

export default TransferOrderResume;
